// <s-carousel> wires previous/next buttons to a horizontally scrolling, scroll-snapped track.
// Markup: [data-carousel-track], [data-carousel-prev], [data-carousel-next].
// Native swipe/trackpad scrolling works without JS; buttons page by one visible width.
class Carousel extends HTMLElement {
  #track = null;
  #prev = null;
  #next = null;
  #onScroll = () => this.#update();

  connectedCallback() {
    this.#track = this.querySelector('[data-carousel-track]');
    this.#prev = this.querySelector('[data-carousel-prev]');
    this.#next = this.querySelector('[data-carousel-next]');
    if (!this.#track) return;

    this.#prev?.addEventListener('click', () => this.#page(-1));
    this.#next?.addEventListener('click', () => this.#page(1));
    this.#track.addEventListener('scroll', this.#onScroll, { passive: true });
    window.addEventListener('resize', this.#onScroll, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    this.#track?.removeEventListener('scroll', this.#onScroll);
    window.removeEventListener('resize', this.#onScroll);
  }

  #page(direction) {
    const rtl = getComputedStyle(this.#track).direction === 'rtl' ? -1 : 1;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.#track.scrollBy({ left: direction * rtl * this.#track.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' });
  }

  #update() {
    const { scrollWidth, clientWidth } = this.#track;
    const position = Math.abs(this.#track.scrollLeft);
    const overflowing = scrollWidth > clientWidth + 1;
    this.toggleAttribute('data-overflowing', overflowing);
    if (this.#prev) this.#prev.disabled = position <= 1;
    if (this.#next) this.#next.disabled = position + clientWidth >= scrollWidth - 1;
  }
}

if (!customElements.get('s-carousel')) {
  customElements.define('s-carousel', Carousel);
}
